module.exports = __webpack_public_path__ + "img/six.3c97c817.png";